/*
 * @Author: lishiqiao
 * @Date: 2022-01-18 14:35:44
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-11 15:07:17
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:11:19
     * @description: 销售量-区域下拉
     * @param {*} params
     */
    getVolumeGroupList(params) {
        const url = `/outSaleDailyGroup/getGroupConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:12:45
     * @description: 销售量-品种下拉
     * @param {*} params
     */
    getVolumeBreedList(params) {
        const url = `/outSaleDailyGroup/getBreedConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:13:19
     * @description: 销售量-造次下拉
     * @param {*} params
     */
    getVolumePeriodList(params) {
        const url = `/outSaleDailyGroup/gePeriodConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:14:21
     * @description: 销售量-品类下拉
     * @param {*} params
     */
    getVolumeBreedTypeList(params) {
        const url = `/outSaleDailyGroup/geTypeConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:31:18
     * @description: 销售量-分页
     * @param {*} params
     */
    getVolumePageList(params) {
        const url = `/outSaleDailyGroup/searchOutSaleDailyGroupList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 14:48:49
     * @description: 销售量-导出
     * @param {*} params
     */
    exportVolumeData(params) {
        const url = `/outSaleDailyGroup/exportOutSaleDailyGroupList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:22:05
     * @description: 销售量明细-根据角色权限获取养殖场下拉列表
     * @param {*}
     */
    getDetailBaseList() {
        const url = '/baseData/queryBaseDataListByRole';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:24:11
     * @description: 销售量明细-获取基地下的除总仓下的区域
     * @param {*} baseId
     */
    getDetailGroupList(baseId) {
        const url = '/baseGroup/queryBaseGroupList';
        return http.post(url, {
            baseId: baseId,
            groupFlag: 0,
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:25:57
     * @description: 销售量明细-单元塘口下拉
     * @param {*} groupId
     */
    getDetailBoxList(groupId) {
        const url = '/boxData/listDataPermissionBoxData/' + groupId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:27:32
     * @description: 销售量明细-生产造次下拉
     * @param {*} orgId
     */
    getDetailPeriodList(orgId) {
        const url = '/periodData/getByBaseIdPeriod/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:29:11
     * @description: 销售量明细-品种下拉
     * @param {*} orgId
     */
    getDetailBreedList(orgId) {
        const url = '/breedData/getListMap/orgId/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-11 14:52:54
     * @description: 销售量明细-批次下拉
     * @param {*} baseId
     */
    getDetailBatchList(baseId) {
        const param = {
            baseId: baseId
        };
        const url = '/harvestEggData/queryBatchNum';
        return http.post(url, param);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:35:28
     * @description: 根据机构id获取一级机构信息
     * @param {*} orgId
     */
    getOrgInfoByOrgId(orgId) {
        const url = '/org/getParentOrg/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:30:56
     * @description: 销售量明细-分页
     * @param {*} params
     */
    getDetailPageList(params) {
        const url = '/harvestEggData/getHarvestEggDataList';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 15:32:03
     * @description: 销售量明细-导出
     * @param {*} params
     */
    exportDetailData(params) {
        const url = `/harvestEggData/getHarvestEggDataExportTable`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 17:10:32
     * @description: 客户-客户下拉
     * @param {*} params
     */
    getCustomerList(params) {
        const url = '/outMoneyReceive/getCustomerConditions';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 17:12:08
     * @description: 客户-类型下拉
     * @param {*} params
     */
    getCustomerTypeList(params) {
        const url = '/outMoneyReceive/getTypeConditions';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 17:13:18
     * @description: 客户-分页
     * @param {*} params
     */
    getCustomerPageList(params) {
        const url = '/outMoneyReceive/getMiddleLayeroutMoneyReceive';
        return http.post(url, params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 17:14:10
     * @description: 客户-导出
     * @param {*} params
     */
    exportCustomerData(params) {
        const url = `/outMoneyReceive/exportMiddleLayeroutMoneyReceiveList`;
        return Page.exportDatas(url, params)
    },
}